import { useDisplayUserName } from 'hooks/useDisplayUserName'
import Styles from './Actor.module.scss'
import { ActorProps } from './Types'

const Actor = ({ name, actorId, capitalize = false, genitive = false }: ActorProps) => {
  const displayName = useDisplayUserName(name, actorId, capitalize, genitive)

  return <span className={Styles.actor}>{displayName}</span>
}

export { Actor }
